import api from "./axios";
import { API_URL } from "../constants/constants";
import { getUserFromLocalStorage } from "./localStorage";

// Sends a file to S3 through our own API.
//
// It used to go straight from the browser to S3 with react-aws-s3, which needs
// an accessKeyId and a secretAccessKey to construct. Those came from
// REACT_APP_ACCESS and REACT_APP_SECRET, and every REACT_APP_ variable is
// baked into the bundle at build time, so both halves of a live AWS key pair
// were being handed to everyone who opened the app. Nothing about that is
// fixable on the client: a browser cannot hold a secret. The credentials
// belong on the server, which already had the route and the SDK for this.
//
// Still S3 either way. The API stores the object with the same key shape and
// the same public URL as before; only the thing holding the key changed.

// For rc-upload, which posts with its own XMLHttpRequest and so never passes
// through the axios interceptor that attaches the token. The upload routes
// require a signed-in user, so an uploader that does not send this gets a 401.
export const authHeaders = () => {
  const token = getUserFromLocalStorage()?.token;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const IMAGE = "image";
export const FILE = "file";

// S3 keys keep their extension, because it is what decides the content type a
// browser is given when the file is fetched back. A Blob has no name at all,
// which is what the image editor hands over, and the old code pasted its
// undefined straight into the key.
const EXTENSION_FOR = {
  "image/png": ".png",
  "image/jpeg": ".jpg",
  "image/webp": ".webp",
  "image/gif": ".gif",
};

export const nameFor = (fileObject, fallback, kind = IMAGE) => {
  if (fileObject?.name) return fileObject.name;
  const base = fallback || `${kind}_${Date.now()}`;
  if (/\.[a-z0-9]{2,5}$/i.test(base)) return base;
  return base + (EXTENSION_FOR[fileObject?.type] || "");
};

export const uploadToS3 = async (fileObject, { kind = IMAGE, fallbackName, onProgress } = {}) => {
  const field = kind === FILE ? FILE : IMAGE;
  const body = new FormData();
  body.append(field, fileObject, nameFor(fileObject, fallbackName, field));

  const res = await api.post(`${API_URL}/api/v1/upload/${field}`, body, {
    // No Content-Type on purpose. Only the browser knows the multipart
    // boundary, and setting the header by hand produces one without it, which
    // the server cannot read.
    onUploadProgress: (event) => {
      if (!onProgress || !event.total) return;
      onProgress(Math.round((100 * event.loaded) / event.total));
    },
  });

  // The route answers { secure_url }. The bare-string form is accepted so this
  // also works against an older API.
  const url = res?.data?.secure_url || res?.data;
  if (typeof url !== "string" || !url) throw new Error("Upload did not return a URL");
  return url;
};

export default uploadToS3;
